/* CW Werkstattservice: setzt Hulks Advanced JS auf einen kleinen Asset-Loader. */
(function () {
  if (!/(^|\/)pages\/werkstattservice\/?$/.test(window.location.pathname)) {
    return;
  }

  var hulkFormBuilder = window.hulkFormBuilder;
  var forms = hulkFormBuilder && hulkFormBuilder.form_data;
  var formEntry = forms && forms.form_yLmBSU9KgTgewLaPTAu6MA;
  var formData = formEntry && formEntry.form_data;

  if (!formData) {
    return;
  }

  var assetUrl = 'https://www.colognewatch.de/cdn/shop/t/137/assets/cw-hulk-workshop-service-form-locale.js';

  try {
    if (document.currentScript && document.currentScript.src) {
      assetUrl = new URL('cw-hulk-workshop-service-form-locale.js', document.currentScript.src).toString();
    }
  } catch (error) {}

  assetUrl = assetUrl.split('?')[0];
  assetUrl += '?cw_v=20260512-workshop-locale-v9511';

  formData.advance_js = '(function(){var s=document.createElement("script");s.src=' + JSON.stringify(assetUrl) + ';document.head.appendChild(s);}());';
})();
